/* =============================================================
   WYE & HOUND — Theme JavaScript
   ============================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ── SEARCH OVERLAY ── */
  const searchOverlay = document.getElementById('searchOverlay');
  const searchOpenBtns = document.querySelectorAll('[data-search-open]');
  const searchClose = document.querySelector('.search-close');

  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      searchOverlay.classList.add('open');
      setTimeout(function () {
        searchOverlay.querySelector('input').focus();
      }, 100);
    });
  });

  if (searchClose) {
    searchClose.addEventListener('click', function () {
      searchOverlay.classList.remove('open');
    });
  }

  if (searchOverlay) {
    searchOverlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') searchOverlay.classList.remove('open');
    });
  }

  /* ── MOBILE MENU ── */
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileClose = document.querySelector('.mobile-menu-close');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', function () {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  /* ── ACCORDION ── */
  document.querySelectorAll('.accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.accordion-item').forEach(function (i) {
        i.classList.remove('open');
      });
      // Toggle clicked
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── GALLERY THUMBNAILS ── */
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const src = this.dataset.src;
      const full = this.dataset.full;
      const mainImg = document.getElementById('mainImg');
      if (mainImg && src) {
        mainImg.src = src;
        if (full) mainImg.dataset.full = full;
        document.querySelectorAll('.gallery-thumb').forEach(function (t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

  /* ── LIGHTBOX ── */
  const lightbox = document.getElementById('whLightbox');
  const lightboxImg = document.getElementById('whLightboxImg');
  const mainImg = document.getElementById('mainImg');
  const galleryMain = document.querySelector('.gallery-main');

  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (galleryMain) {
    galleryMain.addEventListener('click', function () {
      const img = document.getElementById('mainImg');
      if (img) openLightbox(img.dataset.full || img.src, img.alt);
    });
  }

  if (lightbox) {
    document.getElementById('whLightboxOverlay').addEventListener('click', closeLightbox);
    document.getElementById('whLightboxClose').addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  /* ── COLOUR SELECTOR ── */
  document.querySelectorAll('.colour-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const group = btn.closest('.colour-options');
      group.querySelectorAll('.colour-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      const nameEl = document.getElementById('colourName');
      if (nameEl) nameEl.textContent = btn.dataset.colour || '';
    });
  });

  /* ── SIZE SELECTOR ── */
  document.querySelectorAll('.size-btn:not(.oos)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.size-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      const nameEl = document.getElementById('sizeName');
      if (nameEl) {
        nameEl.textContent = (btn.dataset.size || '') + ' — ' + (btn.dataset.range || '');
      }
    });
  });

  /* ── SIZE GUIDE MODAL ── */
  const sizeGuideLinks = document.querySelectorAll('.size-guide-link');
  sizeGuideLinks.forEach(function(sizeGuideLink) {
    sizeGuideLink.addEventListener('click', function () {
      const guide = this.dataset.guide === 'lead' ? 'sizeGuideLead' : 'sizeGuideCollar';
      const sizeModal = document.getElementById(guide);
      if (sizeModal) sizeModal.classList.add('open');
    });
  });
  document.querySelectorAll('.sg-close, .sg-modal').forEach(function(el) {
    el.addEventListener('click', function(e) {
      if (e.target === el) el.closest('.sg-modal').classList.remove('open');
    });
  });


  /* ── QUANTITY ── */
  document.querySelectorAll('.qty-minus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-wrap').querySelector('.qty-val');
      if (input) input.value = Math.max(1, parseInt(input.value) - 1);
    });
  });

  document.querySelectorAll('.qty-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-wrap').querySelector('.qty-val');
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  /* ── COLLECTION FILTERS ── */
  document.querySelectorAll('.colour-filter').forEach(function (filter) {
    filter.addEventListener('click', function () {
      this.classList.toggle('active');
    });
  });

  document.querySelectorAll('.filter-list a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!this.href || this.href === '#') {
        e.preventDefault();
        document.querySelectorAll('.filter-list a').forEach(function (l) {
          l.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

  /* ── CART COUNT UPDATE ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  updateCartCount();

  /* ── ADD TO CART ── */
  const atcBtn = document.querySelector('.btn-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      const qty = parseInt(document.querySelector('.qty-val')?.value || 1);
      if (!variantId) return;

      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: (function() {
        var form = document.getElementById('productForm');
        if (form) {
          var formData = new FormData(form);
          var data = { items: [{ id: variantId, quantity: qty }] };
          var properties = {};
          formData.forEach(function(value, key) {
            if (key.indexOf('properties[') === 0) {
              var propName = key.replace('properties[', '').replace(']', '');
              if (value !== '') properties[propName] = value;
            }
          });
          if (Object.keys(properties).length > 0) {
            data.items[0].properties = properties;
          }
          return JSON.stringify(data);
        }
        return JSON.stringify({ items: [{ id: variantId, quantity: qty }] });
      })()
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          atcBtn.textContent = 'Added!';
          setTimeout(function () {
            atcBtn.textContent = 'Add to bag';
            atcBtn.disabled = false;
          }, 2000);
          updateCartCount();
        })
        .catch(function () {
          atcBtn.textContent = 'Error — try again';
          atcBtn.disabled = false;
        });
    });
  }

  /* ── PREDICTIVE SEARCH ── */
  const searchInput = document.querySelector('.search-form input');
  if (searchInput) {
    let searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      const q = this.value.trim();
      if (q.length < 2) return;
      searchTimer = setTimeout(function () {
        // Predictive search via Shopify API
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            // Results handled by form submit for now
          });
      }, 300);
    });
  }

});
